import { Messages } from "../../lib/locale";

export const English: Messages = {
  name: "English",
  helpTitle: "How to play",
  help1: `Your task is to find out which country is hidden in the game. To do this, you need to enter the names of random countries. Write the country in the input box and press Enter. This country will appear on the map and change color depending on how close it is to the hidden country. The darker the color, the closer you are to the answer!`,
  help2: `Look at the game example. Let's say the country Japan is hidden in the game. Then these countries will be painted in such colors.`,
  help3: `Once a day, one new hidden country is available. Or switch to practice mode in the settings and play unlimited.`,
  France: "France",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "South Korea",
  Aux1: `<b>["Click", "Tap"]</b> the globe to start!`,
  Loading: "Wait for it...",
  GameTitle: "Game",
  Game1: "Enter country name here",
  Game2: "Enter",
  Game3: "Type in a random country name and press Enter to start",
  Game4: `Spin, <span>["click", "touch"]</span>, and zoom the globe to find the next country to guess`,
  Game5: "We don't know this country",
  Game6: "This country is already entered",
  Game7: "The Hidden Country is {answer}!",
  Game8: "Closest border",
  StatsTitle: "Statistics",
  Stats1: "Last win",
  Stats2: "Today's guesses",
  Stats3: "Games won",
  Stats4: "Current streak",
  Stats5: "Max streak",
  Stats6: "Average guesses",
  Stats7: "Avg. Guesses",
  Stats8: "Reset",
  Stats9: "Share",
  Stats10: "Are you sure you want to reset your score?",
  Stats11: "Stats erased.",
  Stats12: "Copied to clipboard!",
  SettingsTitle: "Settings",
  Settings1: "Day Theme",
  Settings2: "Night Theme",
  Settings3: "Colour Blind Mode",
  Settings4: "Colour Blind Mode",
  Settings5: "Countries",
  Settings7: "Language",
  Settings9: "Practice",
  Settings10: "Hints",
  Answer: "Answer",
  Closest: "Closest",
  Guessed: "Guessed",
  PracticeMode: "You are in practice mode.",
  PracticeExit: "Exit practice mode",
  PracticeNew: "New practice game",
  PlayAgain: "Play again",
  SortBy: "Sort by:",
  SortByGuesses: "order of guesses",
  SortByDistance: "distance",
  Clipboard: "🌍🌍🌍\nI guessed the hidden country in today's Globle\nin {X} guesses\nCan you do it better?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Victory",
  Guesses: "Guesses",
  GuessesFlags: "Your guesses will be here",
  Daily: "Daily",
  NextDailyIn: "Next Daily in",
  Learn: "Learn more about this country"
};
